<app-loading-spinner [active]="loading"></app-loading-spinner>

<form [formGroup]="form">

    <ng-container *ngIf="!showForm">
        <app-table [columns]="columns" [data]="data" [footerData]="footerData"
            (onRemove)="handleOpenDeleteModal($event)">
        </app-table>
        <app-spacer [bottom]="35"></app-spacer>
    </ng-container>

    <ng-container *ngIf="showForm">
        <div class="row">
            <div class="col-12 col-lg-8">
                <app-input [group]="form" controlName="type" label="Tipo">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12 col-lg-4">
                <app-currency-input [group]="form" controlName="current_value"
                    label="Valor atual" placeholder="R$ 000.000,00">
                </app-currency-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-lg-12">
                <app-input [group]="form" controlName="description"
                    [maxLength]="80" label="Descrição">
                </app-input>
                <app-spacer [bottom]="32"></app-spacer>
            </div>
        </div>
    </ng-container>

    <div class="row">
        <div class="col-12 align-items-center">
            <app-button (onClick)="triggerForm()"
                [disabled]="buttonDisabled() || addingOthers"
                class="add-button mr-3" [outline]="true"
                [loading]="addingOthers">
                <svg-icon src="assets/images/icon-add.svg"
                    class="mr-2"></svg-icon>
                Adicionar
            </app-button>

            <app-button (onClick)="handleCancel()" [outline]="true"
                *ngIf="showForm && data.length > 0">
                Cancelar
            </app-button>
        </div>
    </div>
</form>

<app-warning-modal [active]="showDeleteModal" (onClose)="closeDeleteModal()">
    <h3>Atenção</h3>
    <app-spacer [bottom]="24"></app-spacer>

    <p>Você tem certeza que deseja remover este item?</p>
    <app-spacer [bottom]="56"></app-spacer>

    <app-button (onClick)="confirmDeleteOthers()" class="add-button"
        [center]="true" [outline]="true" [loading]="removingOthers"
        [disabled]="removingOthers">
        Sim, remover agora
    </app-button>
    <app-spacer [bottom]="8"></app-spacer>
    <app-button (onClick)="closeDeleteModal()" [center]="true"
        class="add-button">
        Não, quero manter
    </app-button>
</app-warning-modal>